var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"w-full max-w-5xl mx-auto bg-white min-h-screen"},[_c('div',{staticClass:"relative w-full flex flex-col"},[_c('div',{staticClass:"h-screen",attrs:{"id":"logout"}},[_c('vue-loading',{attrs:{"loading":_vm.loading}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }